import {useMemo} from 'react';
import {useChatSessions} from './useChatSessions';
import {chain} from 'lodash';
import {useIndexedUsers} from '../users/useIndexedUsers';

export function useGroupedChatSessions({filter, sort: orderBy} = {}) {
    const sessions = useChatSessions({filter, orderBy}),
        users = useIndexedUsers();

    return useMemo(() => {
        return chain(sessions)
            .map(session => session.otherUserId)
            .uniq()
            .map(userId => ({
                user: users[userId],
                sessions: sessions.filter(session => session.otherUserId == userId),
            }))
            .value();
    }, [sessions, users]);
}
